module.exports = __webpack_public_path__ + "static/media/restroom.1c72d99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/restroom.png
// module id = 412
// module chunks = 0